// extracted by mini-css-extract-plugin
module.exports = {"tools":"SideBarMenu_tools__1I0Oz","hr":"SideBarMenu_hr__2ELwt"};